import React from "react";
import { Box } from "@mui/material";
import IncomeStatementAnalysis from "./IncomeStatementAnalysis";
import { useParams } from "react-router-dom";
import BalanceSheetAnalysis from "./BalanceSheetAnalysis";
import CashFlowAnalysis from "./CashFlowAnalysis";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase-config";

export default function FinancialTrend() {
  let params = useParams();
  const id = params.companyId;
  const [loading, setLoading] = React.useState(true);
  const [years, setYears] = React.useState([]);

  async function getQueryInfo({ id }) {
    setLoading(true);
    const docRef = doc(db, "companies", id);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();
    const dbYears = data["years"].sort(function (a, b) {
      return b - a;
    });
    setYears(dbYears.splice(0, 4));
    setLoading(false);
  }

  React.useEffect(() => {
    getQueryInfo({ id });
  }, [id]);

  return loading ? (
    <h1>Loading</h1>
  ) : (
    <>
      <Box>
        <IncomeStatementAnalysis
          years={years}
          id={id}
          period={"Annual"}
          periodIndex={0}
        />
        <BalanceSheetAnalysis
          years={years}
          id={id}
          period={"Annual"}
          periodIndex={0}
        />
        <CashFlowAnalysis
          years={years}
          id={id}
          period={"Annual"}
          periodIndex={0}
        />
      </Box>
    </>
  );
}
